import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlassSpinner from "../components/GlassSpinner";
import { waitlistSubmit } from "../services/sininApi";
import axios from "axios";

const API = "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod";

export default function WaitlistForm() {
  const { empresaId, eventoId } = useParams();
  const navigate = useNavigate();

  const [cfg, setCfg]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [done, setDone]       = useState(null); // { id, ya_registrado }
  const [error, setError]     = useState("");
  const [form, setForm]       = useState({
    dni: "", first_name: "", last_name: "", email: "", instagram: "", sexo: "", ws: "",
  });

  const GOLD   = cfg?.colorTicket || "#25f4df";
  const FONDO  = cfg?.colorFondo  || "#1a1a1a";
  const FUENTE = cfg?.colorFuente || "#ffffff";

  useEffect(() => {
    axios.post(`${API}/sinin_gestionarEmpresas`, { action: "get", empresaId: empresaId.toLowerCase() })
      .then(r => setCfg(r.data?.empresa || {}))
      .catch(() => setCfg({}))
      .finally(() => setLoading(false));
  }, [empresaId]);

  const setF = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.dni || !form.first_name || !form.last_name) return;
    setSending(true);
    try {
      const res = await waitlistSubmit({ empresaId: empresaId.toLowerCase(), eventoId, ...form });
      console.log("waitlist res:", res);
      if (res?.ok) setDone({ id: res.id, ya_registrado: res.ya_registrado });
      else setError("Error: " + JSON.stringify(res));
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || "desconocido";
      if (msg.includes("WAITLIST_INACTIVA")) setError("La lista de espera está cerrada por el momento.");
      else if (msg.includes("WAITLIST_EXPIRADA")) setError("El link de lista de espera ya expiró.");
      else setError("Error: " + msg);
    }
    setSending(false);
  };

  if (loading) return (
    <div style={{ minHeight: "100vh", background: FONDO, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <GlassSpinner size={60} background={FONDO} />
    </div>
  );

  const inputStyle = {
    width: "100%", padding: "12px 14px", borderRadius: 12, border: "1px solid rgba(255,255,255,.18)",
    background: "rgba(0,0,0,.35)", color: FUENTE, fontSize: 15, boxSizing: "border-box",
    outline: "none", marginBottom: 14,
  };
  const labelStyle = { fontSize: 13, color: "rgba(255,255,255,.7)", display: "block", marginBottom: 4 };

  const empresa_nombre = cfg?.nombre || empresaId.toUpperCase();

  if (done) return (
    <div style={{ minHeight: "100vh", background: FONDO, display: "flex", alignItems: "center",
      justifyContent: "center", padding: 20 }}>
      <div style={{ maxWidth: 400, width: "100%", textAlign: "center" }}>
        {cfg?.logoUrl && (
          <img src={cfg.logoUrl} alt="logo"
            style={{ maxHeight: 70, maxWidth: 180, objectFit: "contain", marginBottom: 20 }} />
        )}
        <div style={{ fontSize: 40, marginBottom: 12 }}>
          {done.ya_registrado ? "✅" : "🎉"}
        </div>
        <div style={{ color: FUENTE, fontSize: 20, fontWeight: "800", marginBottom: 8 }}>
          {done.ya_registrado ? "¡Ya estabas anotado!" : "¡Listo, te anotamos!"}
        </div>
        <div style={{ color: "rgba(255,255,255,.7)", fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>
          {done.ya_registrado
            ? "Ya tenés tu solicitud en lista de espera para este evento."
            : `Gracias por anotarte. Te avisamos si quedaste confirmado para recibir tu entrada a ${empresa_nombre}.`
          }
        </div>
        <button
          onClick={() => navigate(`/espera/${empresaId}/${eventoId}/estado/${form.dni}?id=${done.id}`)}
          style={{
            background: GOLD, color: cfg?.colorFuente || "#042b28", border: "none",
            borderRadius: 25, padding: "14px 24px", cursor: "pointer", fontWeight: "900",
            fontSize: 14, textTransform: "uppercase", width: "100%", marginBottom: 10,
          }}>
          Ver estado de mi entrada
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: FONDO, display: "flex", alignItems: "center",
      justifyContent: "center", padding: 20 }}>
      <div style={{ maxWidth: 420, width: "100%" }}>
        {cfg?.logoUrl && (
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img src={cfg.logoUrl} alt="logo"
              style={{ maxHeight: 70, maxWidth: 180, objectFit: "contain" }} />
          </div>
        )}
        <div style={{ color: FUENTE, fontSize: 22, fontWeight: "800", marginBottom: 4, textAlign: "center" }}>
          {empresa_nombre}
        </div>
        <div style={{ color: "rgba(255,255,255,.55)", fontSize: 13, textAlign: "center", marginBottom: 28 }}>
          Completá tus datos para anotarte en la lista de espera.
        </div>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>Nombre *</label>
          <input style={inputStyle} value={form.first_name} onChange={setF("first_name")}
            placeholder="Tu nombre" required />
          <label style={labelStyle}>Apellido *</label>
          <input style={inputStyle} value={form.last_name} onChange={setF("last_name")}
            placeholder="Tu apellido" required />
          <label style={labelStyle}>DNI *</label>
          <input style={inputStyle} value={form.dni} onChange={setF("dni")}
            placeholder="DNI / Pasaporte" required />
          <label style={labelStyle}>Email</label>
          <input style={inputStyle} value={form.email} onChange={setF("email")}
            placeholder="para enviarte la entrada" type="email" />
          <label style={labelStyle}>Instagram (sin @)</label>
          <input style={inputStyle} value={form.instagram} onChange={setF("instagram")}
            placeholder="tu_usuario" />
          <label style={labelStyle}>WhatsApp (con código de país, sin +)</label>
          <input style={inputStyle} value={form.ws} onChange={setF("ws")}
            placeholder="5491112345678" inputMode="numeric" />
          <label style={labelStyle}>Sexo</label>
          <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
            {["Masculino", "Femenino", "Otro"].map(op => (
              <button key={op} type="button"
                onClick={() => setForm(p => ({ ...p, sexo: op }))}
                style={{
                  flex: 1, padding: "10px 6px", borderRadius: 12, cursor: "pointer",
                  border: form.sexo === op ? `2px solid ${GOLD}` : "1px solid rgba(255,255,255,.2)",
                  background: form.sexo === op ? `${GOLD}33` : "rgba(0,0,0,.3)",
                  color: FUENTE, fontWeight: form.sexo === op ? "800" : "400", fontSize: 13,
                }}>
                {op}
              </button>
            ))}
          </div>

          {error && <div style={{ color: "#ff6b6b", fontSize: 13, marginBottom: 10 }}>{error}</div>}
          <button type="submit" disabled={sending}
            style={{
              background: GOLD, color: cfg?.colorFuente || "#042b28", border: "none",
              borderRadius: 25, padding: "14px 24px", cursor: "pointer", fontWeight: "900",
              fontSize: 14, textTransform: "uppercase", width: "100%",
              opacity: sending ? 0.65 : 1,
            }}>
            {sending ? "Enviando..." : "Anotarme"}
          </button>
        </form>
      </div>
    </div>
  );
}
